import { Container, Grid } from "@mui/material";
import { makeStyles } from '@mui/styles';
import CloseIcon from "@mui/icons-material/Close";
import Select from "../UI/Select";
import CircularProgress from "@mui/material/CircularProgress";
import TextFieldDateTime from "../UI/TextFieldDateTime";
import Button from "../UI/Button";
import dayjs from "dayjs";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: "20px",
    marginBottom: "20px",
    display: "flex",
    flexDirection: "column",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: (1),
  },
  submit: {
    margin: (3, 0, 2),
  },
  closeIcon: {
    marginTop: "20px",
    cursor: "pointer",
  },
  loading: {
    marginRight: "10px",
    marginLeft: "10px",
  },
}));

const CatracaRegistroForm = ({
  catracaRegistro,
  setCatracaRegistro,
  handleSave,
  isLoadingSave,
}) => {
  const classes = useStyles();
  const listEntradaSaida = [
    { description: "Entrada", value: "ENTRADA" },
    { description: "Saída", value: "SAIDA" },
  ];

  const onChangeEntradaSaida = (event) => {
    setCatracaRegistro((prevState) => ({
      ...prevState,
      entradaSaida: event.target.value,
    }));
  };

  const handleDateTimeChange = (dateTime) => {
    setCatracaRegistro({
      ...catracaRegistro,
      dataHora: dayjs(dateTime),
    });
  };

  return (
    <Container className={classes.paper} >
      <Grid container spacing={4}>
        <Grid size={12}>
          <div className={classes.closeIcon}>
            <CloseIcon onClick={() => setCatracaRegistro(null)} fontSize="small" />
          </div>
        </Grid>

        <Grid size={6}>
          <form onSubmit={handleSave}>
            <Grid container spacing={3}>
              <Grid size={12}>
                <TextFieldDateTime
                  fullWidth
                  required
                  label="Data Hora"
                  value={
                    catracaRegistro && catracaRegistro.dataHora
                      ? catracaRegistro.dataHora
                      : null
                  }
                  onChange={handleDateTimeChange}
                />
              </Grid>
              <Grid size={12}>
                <Select
                  label="Entrada/Saída"
                  value={
                    catracaRegistro && catracaRegistro.entradaSaida
                      ? catracaRegistro.entradaSaida
                      : ""
                  }
                  list={listEntradaSaida}
                  onChange={onChangeEntradaSaida}
                />
              </Grid>

              <Grid>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  disabled={isLoadingSave}
                  color="primary"
                  className={classes.submit}
                >
                  {isLoadingSave && (
                    <CircularProgress
                      className={classes.loading}
                      color="primary"
                      size={20}
                    />
                  )}
                  Salvar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CatracaRegistroForm;
